(function ($, window, document, undefined) {

    'use strict';

    // Plugin Defaults
    var pluginName = 'profoundDrop';
    var defaults = {
        'z-index': 99999
    };
    var BORDER_WIDTH = 1;
    var BORDER_COLOR = '#d7d7d7';
    var MAX_HEIGHT = 300;

    function ProfoundDrop (element, options) {
        // general vars
        this.element = $(element);
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;

        // plugin specific vars
        this.elDropdownWrapper = null;
        this.elDropdownHeader = null;
        this.elDropdownButton = null;
        this.elDropdownMenu = null;
        this.elSelect = this.element; // reference to the native element, if it exists
        this.expandedHeight = 0;
        this.isExpanded = false;
        // init
        this.init();
    }

    /**
     * Plugin Functions.
     */
    ProfoundDrop.prototype = {
        /**
         * Init Function, called upon instantiation.
         */
        init: function () {
            this.processMarkup();
            this.calculateExpandedHeight();
            this.addEventListeners();
            this.testForMobile();
        },
        /**
         * Processes markup initially. 
         */
        processMarkup: function() {

            // create the element wrapper
            var html = '<div class="profounddrop';
            if (this.element.hasClass('disabled') === true) {
                html += ' disabled';
            }
            html += '"></div>';
            this.element.wrap(html);
            this.element = this.element.parent();
            this.element.prepend('<span class="icon icon_arrow-down"></span>');

           
            this.elSelect.hide();

            var menuHtml = '<div class="dropdown-wrapper">';

            var selected = this.elSelect.find(':selected');
            if (!selected){
                selected = this.elSelect.find('option').first();
            }
            menuHtml += '<h6><a href="#">' + selected.text() + '<span class="icon icon_arrow-down"></span></a></h6>';
            
            menuHtml += '<ul>';
            this.elSelect.find('option').each(function(){
                menuHtml += '<li><a href="#" data-val="' + encodeURIComponent($(this).val()) + '">' + $(this).text() + '</a></li>';
            });
            menuHtml += '</ul></div>';
            this.element.append(menuHtml);


            this.elDropdownWrapper = this.element.find('.dropdown-wrapper');
            this.elDropdownHeader = this.elDropdownWrapper.find('div');
            this.elDropdownButton = this.elDropdownWrapper.find('a').first();
            this.elDropdownMenu = this.elDropdownWrapper.find('ul');
            this.elDropdownMenu.addClass('profounddrop-menu');
            $(window).on('resize', $.proxy(this.onResize, this));
        },
        /**
         * Calculates the expanded height of the dropdown.
         */
        calculateExpandedHeight: function () {
            var borderGrey = BORDER_WIDTH + 'px solid ' + BORDER_COLOR;

            this.element.css({
                'width': this.element.width(),
                'height': this.element.height()
            });

            this.elDropdownMenu.css('height', 'auto');
            this.expandedHeight = this.elDropdownMenu.height();

            if (this.expandedHeight > MAX_HEIGHT) {
                this.expandedHeight = MAX_HEIGHT;
                this.elDropdownMenu.css({
                    'overflow': 'auto',
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden',
                    'max-height': '300px'
                });
            }

            this.elDropdownMenu.css({
                'height': '0px',
                'width': this.element.width(),
                'border-left': borderGrey,
                'border-right': borderGrey,
                'border-bottom': borderGrey
            });
            this.elDropdownWrapper.css('overflow', 'hidden');
            this.element.css('overflow', 'visible');

        },
        /**
         * Adds event listeners.
         */
        addEventListeners: function() {
            this.elDropdownButton.on('click', $.proxy(this.toggle, this));
            this.elDropdownMenu.find('a').on('click', $.proxy(this.onSelection, this));
            $( window ).on( 'click', $.proxy(this.onClickWindow, this));
        },
        /**
         * Toggles the dropdown.
         */
        toggle: function(e) {
            e.preventDefault();
            if (this.isExpanded) {
                this.close();
            } else if (this.element.hasClass('disabled') === false) {
                this.expand();
            }
        },
        /**
         * Opens the dropdown.
         */
        expand: function() {
            this.element.addClass('expanded');
            this.elDropdownMenu.appendTo($('body'));
            this.reposition();

            this.isExpanded = true;
            this.elDropdownMenu.stop();
            this.elDropdownMenu.animate({'height': this.expandedHeight}, 50);
        },
        /**
         * Closes the dropdown.
         */
        close: function() {
            var _this = this;
            this.element.removeClass('expanded');
            this.isExpanded = false;
            this.elDropdownMenu.stop();
            this.elDropdownMenu.animate({'height': '0px'}, 50, function() {
                $(this).appendTo(_this.element);
            });
        },
        /**
         * Positions the menu absolutely inside the body, right under the dropdown element.
         */
        reposition: function() {
            var offset = this.element.offset();
            this.elDropdownMenu.css({
                'top': offset.top + this.element.height(),
                'left': offset.left
            });
        },
        /**
         * Event handler for click inside window. Closes dropdown if click wasn't inside the dropdown.
         */
        onClickWindow: function(e) {
            var elTarget = $(e.target);
            if (this.isExpanded && elTarget.is(this.elDropdownButton) === false) {
                this.close();
            }
        },
        /**
         * Event handler that gets triggered on window resize.
         */
        onResize: function() {
            // reposition dropdown menu
            this.reposition();
            // decide whether to display mobile or desktop version
            this.testForMobile();
        },
        /**
         * Event handler that gets triggered when user makes a selection from the dropdown.
         */
        onSelection: function(e) {
            e.preventDefault();
            var selected = $(e.target);
            var dataVal = selected.attr('data-val');
            // update the dropdown header button
            this.elDropdownButton.html(selected.text() + '<span class="icon icon_arrow-down"></span>');
            // unselect currently selected option
            this.elSelect.find('option:selected').removeAttr('selected');
            // select new choice
    	    this.elSelect.find('option').each(function(){
              if ($(this).text() === decodeURIComponent(dataVal)) {
                $(this).attr('selected', true);
              }
 	        });
            this.elSelect.change();
            // close dropdown
            this.close();
        },
        /**
         * On mobile, use the select item itself, because of native UI support.
         */
        testForMobile: function() {
            var isMobile = false;

            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                isMobile = true;
            }

            if( $(window).width() < 600) {
                isMobile = true;
            }

            if (isMobile) {
                this.elDropdownMenu.stop();
                this.elDropdownMenu.css('height', '0px');
                this.elDropdownMenu.hide();
                this.elSelect.show();
                this.elDropdownWrapper.hide();
            } else {
                this.elSelect.hide();
                this.elDropdownWrapper.show();
                this.elDropdownMenu.show();
            }
        }
    };

    // Plugin wrapper around the constructor, preventing against multiple instantiations.
    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data( this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new ProfoundDrop(this, options));
            }
        });
        // chain jQuery functions
        return this;
    };

})( jQuery, window, document );